import styled from 'styled-components';

export const StyledSpinner = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;
